(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bru-daily-funnel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFunnel(root) {
    if (!root || root.dataset.bdfReady === '1') return;
    root.dataset.bdfReady = '1';

    var sectionId = root.id.replace('bdf-', '');
    var dataEl = document.querySelector('[data-bdf-data="' + sectionId + '"]');
    if (!dataEl) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = (DATA.variants || []).filter(function (v) { return v.available; });
    if (!variants.length) variants = DATA.variants || [];
    if (!variants.length) return;

    var flavorMeta = {};
    root.querySelectorAll('[data-flavor-meta]').forEach(function (el) {
      flavorMeta[el.getAttribute('data-flavor-meta')] = {
        sub: el.getAttribute('data-sub') || '',
        img: el.getAttribute('data-img') || ''
      };
    });

    var qty = 1;
    var extraPct = 0;
    var activePlan = DATA.planId;   // overridden per tier when a tier pins its own
    var picks = [variants[0].flavor];

    function money(cents) {
      var fmt = DATA.moneyFormat || '';
      var amount = (cents / 100).toFixed(2);
      if (fmt.indexOf('amount_no_decimals') > -1 && cents % 100 === 0) {
        amount = String(Math.round(cents / 100));
      }
      var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (!fmt) return '$' + withCommas;
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, withCommas);
    }

    function variantFor(flavor) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].flavor === flavor) return variants[i];
      }
      return variants[0];
    }

    // Unit prices come from Shopify, never from a setting.
    function planEntry(flavor, planId) {
      var v = variantFor(flavor);
      if (!planId || !v.plans) return null;
      return v.plans[String(planId)] || null;
    }

    function unitPlanPrice(flavor, planId) {
      var id = planId || activePlan;
      var entry = planEntry(flavor, id);
      if (entry) return entry.price;
      var v = variantFor(flavor);
      return (v.planPrice != null) ? v.planPrice : v.price;
    }

    // "$39.89 for your first 3 orders, then $55.99" comes from the plan's
    // own price adjustments, so a dynamic-pricing plan describes itself
    // and a flat plan just says the one price.
    function renewalSentence(flavor, planId, q) {
      var entry = planEntry(flavor, planId || activePlan);
      if (!entry || !entry.steps || entry.steps.length < 2) return '';
      var intro = entry.steps[0];
      var after = entry.steps[entry.steps.length - 1];
      if (!intro.orderCount) return '';
      var n = intro.orderCount;
      return money(applyExtra(intro.price, extraPct) * q) + ' for your first ' + n +
             ' order' + (n === 1 ? '' : 's') + ', then ' +
             money(applyExtra(after.price, extraPct) * q);
    }
    function unitListPrice(flavor) {
      return variantFor(flavor).price;
    }

    function applyExtra(cents, pct) {
      if (!pct) return cents;
      return Math.round(cents * (100 - pct) / 100);
    }

    // Shopify rounds an automatic discount on each unit and then
    // multiplies. Rounding the total instead drifts by a cent or two,
    // and a total that disagrees with checkout is the whole bug class
    // this section exists to avoid. Round per unit, then sum.
    function tierTotals(q, pct, planId) {
      // Tier previews use the first flavor as the reference unit price.
      var ref = variants[0].flavor;
      var sub = applyExtra(unitPlanPrice(ref, planId), pct) * q;
      var list = unitListPrice(ref) * q;
      return { sub: sub, list: list };
    }

    function selectionTotals() {
      var sub = 0, list = 0;
      for (var i = 0; i < qty; i++) {
        sub += applyExtra(unitPlanPrice(picks[i], activePlan), extraPct);
        list += unitListPrice(picks[i]);
      }
      return { sub: sub, list: list };
    }

    // ---------- step 1 ----------
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));

    function paintTiers() {
      tiers.forEach(function (t) {
        var q = parseInt(t.getAttribute('data-qty'), 10) || 1;
        var pct = parseFloat(t.getAttribute('data-extra')) || 0;
        var tPlan = t.getAttribute('data-plan') || DATA.planId;
        var tot = tierTotals(q, pct, tPlan);
        var now = t.querySelector('[data-tier-now]');
        var was = t.querySelector('[data-tier-was]');
        var off = t.querySelector('[data-tier-off]');
        var renew = t.querySelector('[data-tier-renew]');

        if (now) now.textContent = money(tot.sub);
        if (was) was.textContent = tot.list > tot.sub ? money(tot.list) : '';
        if (off) {
          if (tot.list > tot.sub) {
            var pctOff = Math.round((1 - tot.sub / tot.list) * 100);
            off.textContent = pctOff + '% off';
          } else {
            off.textContent = '';
          }
        }
        if (renew) {
          var stepped = renewalSentence(variants[0].flavor, tPlan, q);
          if (stepped) {
            renew.textContent = stepped;
          } else if (DATA.planId) {
            renew.textContent = 'then ' + money(applyExtra(unitPlanPrice(variants[0].flavor, tPlan), pct) * q) + ' per delivery';
          } else {
            renew.textContent = '';
          }
        }
      });
    }

    function paintGifts() {
      root.querySelectorAll('[data-gift]').forEach(function (g) {
        var min = parseInt(g.getAttribute('data-min'), 10) || 1;
        g.classList.toggle('is-on', qty >= min);
      });
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        t.setAttribute('aria-pressed', 'true');
        qty = parseInt(t.getAttribute('data-qty'), 10) || 1;
        extraPct = parseFloat(t.getAttribute('data-extra')) || 0;
        activePlan = t.getAttribute('data-plan') || DATA.planId;
        picks = [];
        for (var i = 0; i < qty; i++) picks.push(variants[0].flavor);
        paintGifts();
      });
    });

    var preselected = tiers.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; })[0];
    if (!preselected && tiers.length) {
      tiers[0].setAttribute('aria-pressed', 'true');
      preselected = tiers[0];
    }
    if (preselected) {
      qty = parseInt(preselected.getAttribute('data-qty'), 10) || 1;
      extraPct = parseFloat(preselected.getAttribute('data-extra')) || 0;
      activePlan = preselected.getAttribute('data-plan') || DATA.planId;
      picks = [];
      for (var i = 0; i < qty; i++) picks.push(variants[0].flavor);
    }

    // ---------- step 2 ----------
    var grid = root.querySelector('[data-flavor-grid]');

    function renderFlavors() {
      if (!grid) return;
      grid.innerHTML = '';
      for (var i = 0; i < qty; i++) {
        (function (idx) {
          var row = document.createElement('div');
          row.className = 'bdf__frow';

          var label = document.createElement('span');
          label.className = 'bdf__frowlabel';
          label.textContent = qty === 1 ? 'Flavor' : 'Pouch ' + (idx + 1);
          row.appendChild(label);

          variants.forEach(function (v) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'bdf__fbtn';
            b.setAttribute('aria-pressed', picks[idx] === v.flavor ? 'true' : 'false');
            if (!v.available) b.disabled = true;

            var chip = document.createElement('span');
            chip.className = 'bdf__fchip';
            var meta = flavorMeta[v.flavor];
            if (meta && meta.img) chip.style.backgroundImage = 'url(' + meta.img + ')';

            var wrap = document.createElement('span');
            var nm = document.createElement('span');
            nm.className = 'bdf__fname';
            nm.textContent = v.flavor;
            wrap.appendChild(nm);
            if (meta && meta.sub) {
              var sub = document.createElement('span');
              sub.className = 'bdf__fsub';
              sub.textContent = meta.sub;
              wrap.appendChild(sub);
            }

            b.appendChild(chip);
            b.appendChild(wrap);
            b.addEventListener('click', function () {
              picks[idx] = v.flavor;
              renderFlavors();
              paintSummary();
              // The gallery listens for this and swings to that flavor.
              document.dispatchEvent(new CustomEvent('bru:flavor', {
                detail: { flavor: v.flavor }
              }));
            });
            row.appendChild(b);
          });

          grid.appendChild(row);
        })(i);
      }
    }

    function paintSummary() {
      var tot = selectionTotals();
      var noun = qty === 1 ? '1 pouch' : qty + ' pouches';

      var set = function (sel, txt) {
        var el = root.querySelector(sel);
        if (el) el.textContent = txt;
      };

      set('[data-sum-line]', noun);
      set('[data-sum-list]', picks.slice(0, qty).join(', '));
      set('[data-sum-total]', money(tot.sub));
      set('[data-cta-amt]', money(tot.sub));

      var saveRow = root.querySelector('[data-save-row]');
      if (saveRow) {
        if (tot.list > tot.sub) {
          saveRow.hidden = false;
          var pctOff = Math.round((1 - tot.sub / tot.list) * 100);
          set('[data-sum-off-label]', pctOff + '% off');
          set('[data-sum-save]', '-' + money(tot.list - tot.sub));
        } else {
          saveRow.hidden = true;
        }
      }

      var renewEl = root.querySelector('[data-sum-renew]');
      if (renewEl) {
        if (!activePlan) {
          renewEl.textContent = 'One-time purchase.';
        } else {
          var stepped = renewalSentence(picks[0] || variants[0].flavor, activePlan, qty);
          var tail = root.getAttribute('data-renew-copy') || 'Skip, pause or cancel any time.';
          renewEl.textContent = stepped ? stepped + '. ' + tail : tail;
        }
      }

      var subEl = root.querySelector('[data-flavor-sub]');
      if (subEl && subEl.dataset.tmpl) {
        subEl.textContent = subEl.dataset.tmpl.replace('{count}', qty);
      }
    }

    function goStep(n) {
      root.querySelectorAll('[data-stage]').forEach(function (s) {
        s.hidden = (s.getAttribute('data-stage') !== String(n));
      });
      root.querySelectorAll('[data-steplabel]').forEach(function (s) {
        s.classList.toggle('is-on', s.getAttribute('data-steplabel') === String(n));
      });
      if (n === 2) { renderFlavors(); paintSummary(); }
      var top = root.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    var nextBtn = root.querySelector('[data-next]');
    if (nextBtn) nextBtn.addEventListener('click', function () { goStep(2); });
    var backBtn = root.querySelector('[data-back]');
    if (backBtn) backBtn.addEventListener('click', function () { goStep(1); });

    // ---------- checkout ----------
    function buildItems(usePlan) {
      var counts = {};
      for (var i = 0; i < qty; i++) {
        counts[picks[i]] = (counts[picks[i]] || 0) + 1;
      }
      var items = [];
      Object.keys(counts).forEach(function (flavor) {
        var item = { id: variantFor(flavor).id, quantity: counts[flavor] };
        // The tier's own plan, so the cart carries the offer the page showed.
        if (usePlan && activePlan) item.selling_plan = parseInt(activePlan, 10);
        items.push(item);
      });

      // Unlocked gifts ride along as plain $0 line items, deliberately
      // without a selling_plan, so they land on the first order and
      // never on a renewal. A gift with no variant ID is display only.
      root.querySelectorAll('[data-gift]').forEach(function (g) {
        var min = parseInt(g.getAttribute('data-min'), 10) || 1;
        var gid = parseInt(g.getAttribute('data-gift-variant'), 10);
        if (qty >= min && gid) {
          items.push({ id: gid, quantity: 1 });
        }
      });

      return items;
    }

    function showErr(msg) {
      var e = root.querySelector('[data-err]');
      if (!e) return;
      e.textContent = msg;
      e.hidden = false;
    }

    function submitCart(items, btn) {
      if (btn) { btn.disabled = true; }
      var e = root.querySelector('[data-err]');
      if (e) e.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
          return r.json();
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) {
          if (btn) btn.disabled = false;
          showErr(err.message || 'Something went wrong. Please try again.');
        });
    }

    var checkoutBtn = root.querySelector('[data-checkout]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        submitCart(buildItems(true), checkoutBtn);
      });
    }

    // ---------- one-time escape hatch ----------
    var otToggle = root.querySelector('[data-onetime-toggle]');
    var otPanel = root.querySelector('[data-onetime-panel]');
    if (otToggle && otPanel) {
      otToggle.addEventListener('click', function () { otPanel.hidden = !otPanel.hidden; });
    }
    var otPrice = root.querySelector('[data-onetime-price]');
    if (otPrice) otPrice.textContent = money(unitListPrice(variants[0].flavor));
    var otBuy = root.querySelector('[data-onetime-buy]');
    if (otBuy) {
      otBuy.addEventListener('click', function () {
        submitCart([{ id: variantFor(picks[0] || variants[0].flavor).id, quantity: 1 }], otBuy);
      });
    }

    paintTiers();
    paintGifts();
    paintSummary();
  }

  function initAll() {
    document.querySelectorAll('[data-bdf]').forEach(initFunnel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-bdf]');
    if (el) initFunnel(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bru-daily-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGallery(root) {
    if (!root || root.dataset.bdgReady === '1') return;
    root.dataset.bdgReady = '1';

    var track = root.querySelector('[data-track]');
    var dotsWrap = root.querySelector('[data-dots]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if (!track || !slides.length) return;

    var visible = slides.slice();

    function visibleSlides() {
      return slides.filter(function (s) { return !s.hidden; });
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      visible = visibleSlides();
      if (visible.length < 2) return;
      visible.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bdg__dot' + (i === 0 ? ' is-on' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + visible.length);
        b.addEventListener('click', function () { scrollToIndex(i); });
        dotsWrap.appendChild(b);
      });
    }

    function currentIndex() {
      var w = track.clientWidth || 1;
      return Math.round(track.scrollLeft / w);
    }

    function scrollToIndex(i) {
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }

    function paintDots() {
      if (!dotsWrap) return;
      var i = currentIndex();
      Array.prototype.forEach.call(dotsWrap.children, function (d, n) {
        d.classList.toggle('is-on', n === i);
      });
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next-img]');
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= visible.length - 1;
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { paintDots(); ticking = false; });
    });

    var prevBtn = root.querySelector('[data-prev]');
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollToIndex(Math.max(0, currentIndex() - 1)); });
    var nextBtn = root.querySelector('[data-next-img]');
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollToIndex(Math.min(visible.length - 1, currentIndex() + 1)); });

    // Same rule as bru-product-v4: "all" always shows, anything else has
    // to mention the flavor. An unknown flavor falls back to showing all,
    // which is safer than showing an empty gallery.
    function filterTo(flavor) {
      var f = (flavor || '').toLowerCase();
      var matched = 0;

      slides.forEach(function (s) {
        var alt = (s.getAttribute('data-media-alt') || '').toLowerCase();
        var show = !f || alt === 'all' || alt === '' || alt.indexOf(f) !== -1;
        s.hidden = !show;
        if (show) matched++;
      });

      if (!matched) slides.forEach(function (s) { s.hidden = false; });

      track.scrollLeft = 0;
      buildDots();
      paintDots();
    }

    document.addEventListener('bru:flavor', function (e) {
      filterTo(e.detail && e.detail.flavor);
    });

    filterTo(root.getAttribute('data-initial-flavor') || '');
  }

  function initAll() {
    document.querySelectorAll('[data-bdg]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-bdg]');
    if (el) initGallery(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
